import { Icon } from "@fluentui/react";
import styles from "./calculationConstructionNewField.module.scss";
import type ICalculationConstructionNewFieldProps from "./ICalculationConstructionNewFieldProps";

const CalculationConstructionNewField: React.FunctionComponent<ICalculationConstructionNewFieldProps> = ({
    label,
    value,
    highlight,
    isEditable
}) => {
    return (
        <div className={styles.valueBox}>
            <div>{`${label}:`} </div>
            <div className={highlight ? styles.valueYellow : styles.value}>
                {value ?? "-"}
            </div>
            {isEditable && <Icon className={styles.editIcon} iconName="Edit" />}
        </div>
    );
}

export default CalculationConstructionNewField;